import request from '@/utils/request'

// 查询设备列表
export function listDevice(query) {
  return request({
    url: '/iot/device/list',
    method: 'get',
    params: query
  })
}

// 查询设备详细
export function getDevice(id) {
  return request({
    url: '/iot/device/' + id,
    method: 'get'
  })
}

// 查询设备模块列表
export function moduleList(query) {
  return request({
    url: '/iot/device/moduleList',
    method: 'get',
    params: query
  })
}





// WEBPACK FOOTER //
// ./src/api/device.js